import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Fetch } from '@app/models/fetch';
import { Notification } from '@app/models/notifications/notifications.model';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
var NotificationService = /** @class */ (function () {
    function NotificationService(fetch) {
        this.fetch = fetch;
        this.baseUrl = '/notifications';
        // observable for unread notifications
        this._unreadNotifications = new BehaviorSubject(null);
        this.unreadNotifications = this._unreadNotifications.asObservable(); // eslint-disable-line
    }
    NotificationService.prototype.get = function (id) {
        return this.fetch.getOne(this.baseUrl, id).model(Notification);
    };
    NotificationService.prototype.getPage = function (page, options) {
        return this.fetch.getPage(this.baseUrl, page, options).models(Notification);
    };
    NotificationService.prototype.getAll = function (options) {
        return this.fetch.getAll(this.baseUrl, options).models(Notification);
    };
    NotificationService.prototype.getAllDevice = function (id) {
        return this.fetch
            .getAll(this.baseUrl, { device_id: id })
            .req.pipe(map(function (res) { return res.data; }));
    };
    NotificationService.prototype.delete = function (id) {
        return this.fetch.delete(this.baseUrl, id);
    };
    NotificationService.prototype.setRead = function (id, read) {
        return this.fetch.patch(this.baseUrl, id, { read: read });
    };
    NotificationService.prototype.getUnreadNotifications = function (id) {
        var _this = this;
        return this.getAll({ location_id: id, read: false })
            .pipe()
            .subscribe(function (res) {
            _this._unreadNotifications.next(res);
        });
    };
    NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.Fetch)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
export { NotificationService };
